import React from 'react';
import styled from 'styled-components';
import { BsCloudsFill } from 'react-icons/bs';

const Logo = () => {
    return (
        <Container>
            <Icon />
            <Name>multicloud</Name>
        </Container>    )
}

export default Logo;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; /* Align items vertically centered */
`

const Icon = styled(BsCloudsFill)`
    font-size: 40px;
    color: white;
    transform: rotateY(180deg);
    margin-right: 10px; /* Adjust this value as needed */
`

const Name = styled.p`
    color: white;
    margin-top: 0;
`